<template>
  <div>
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row">
          <i class="fa fa-list"></i>
          <span class="card-label fs-3 ms-1">Nhật ký số thứ tự</span>
        </h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <label>Tên khách hàng:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input placeholder="Nhập tên khách hàng" v-model="pageRequest.columnFilters.cHoTenKhachHang.value" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <label>Từ:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-date-picker v-model="pageRequest.columnFilters.tuNgay.value" placeholder="Chọn ngày" type="date"
                  class="w-100" format="DD/MM/YYYY" value-format="DD/MM/YYYY">
                </el-date-picker>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <label>Đến:</label>
            <el-row :gutter="10">
              <el-date-picker v-model="pageRequest.columnFilters.denNgay.value" placeholder="Chọn ngày" type="date"
                class="w-100" format="DD/MM/YYYY" value-format="DD/MM/YYYY">
              </el-date-picker>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <label>Dịch vụ:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-select placeholder="dịch vụ" v-model="pageRequest.columnFilters.nMaDichVu.value">
                  <el-option value="" label="Tất cả">Tất cả</el-option>
                  <el-option v-for="item in service" :key="item.nMaDichVu" :label="item.cTenTrangThai"
                    :value="item.nMaDichVu" selected></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <label>Quầy:</label>
            <div class="d-flex">
              <el-select placeholder="dịch vụ" v-model="pageRequest.columnFilters.nMaQuay.value">
                <el-option value="" label="Tất cả">Tất cả</el-option>
                <el-option v-for="item in booth" :key="item.nMaQuay" :label="item.cTenTrangThai"
                  :value="item.nMaQuay" selected></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <label>Nhân viên:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-select placeholder="dịch vụ" v-model="pageRequest.columnFilters.nMaNhanVien.value">
                  <el-option value="" label="Tất cả">Tất cả</el-option>
                  <el-option v-for="item in employee" :key="item.nMaNhanVien" :label="item.cTenTrangThai"
                    :value="item.nMaNhanVien" selected></el-option>
                </el-select>
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm"
                @click="this.findLog(pageRequest.pageNum, pageRequest.pageSize)" class="ms-2">
                  <i class="fa fa-search"></i>
                </el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div class="body-function">
          <h6>Nhật ký dữ liệu</h6>
        </div>
      </div>
      <div class="card-body">
        <div class="tbl">
          <el-table :data="dataLog.content" style="height: 100%" height="100%" fit>
            <el-table-column label="Tên khách hàng" prop="cHoTenKhachHang" header-align="center"></el-table-column>
            <el-table-column label="Dịch vụ" prop="cTenDichVu" header-align="center"></el-table-column>
            <el-table-column label="Quầy" prop="cTenQuay" header-align="center"></el-table-column>
            <el-table-column label="Nhân viên" prop="cTenNhanVien" header-align="center"></el-table-column>
            <el-table-column label="Số thứ tụ" prop="cSoThuTu"></el-table-column>
            <el-table-column label="Ghi chú" prop="cGhiChu"></el-table-column>
            <el-table-column label="Thời gian">
              <template #default="scope">
                <span v-if="scope.row.dThoiGianBatDau">{{
                  momentDate(scope.row.dThoiGianBatDau) + (scope.row.dThoiGianKetThuc ? " - " +
                    momentDate(scope.row.dThoiGianKetThuc) : "")
                }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination :page-sizes="[5, 10, 20, 30, 50]" background layout="total,sizes,  prev, pager, next"
          :page-size="pageRequest.pageSize" :current-page.sync="pageRequest.pageNum"
          @current-change="handleCurrentChange" @size-change="handleSizeChange" :total="dataLog.totalSize">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import moment from "moment";
import { useStore } from "vuex";
import { Log, CounterLog, Employee, Service, Booth } from "@/store/enums/StoreEnums";
import { ElMessage } from "element-plus";
export default {
  components: {
    VueJsonPretty,
  },
  data() {
    return {
      showLogDetail: false,
      pageRequest: {
        pageNum: 1,
        pageSize: 30,
        columnFilters: {
          nMaDichVu: { value: "" },
          nMaNhanVien: { value: "" },
          nMaQuay: { value: "" },
          cHoTenKhachHang: { value: "" },
          tuNgay: { value: moment(Date.now()).format("01/MM/YYYY") },
          denNgay: { value: moment(Date.now()).format("DD/MM/YYYY") },
        },
      },
      dataLog: {
        totalSize: 0,
        content: [],
      },
      thamsoDT: "",
      thamsoTruoc: "",
      thamsoSau: "",
      store: useStore(),
      employee: [],
      service: [],
      booth: []
    };
  },
  methods: {

    showDetail(val) {
      //console.log(val);
      if (val.substr(val.length - 3) == "...")
        this.thamsoSau = val
      else {
        this.thamsoDT = JSON.parse(val);
        this.thamsoTruoc = this.thamsoDT.old;
        this.thamsoSau = this.thamsoDT.new;
        if (!this.thamsoSau) this.thamsoSau = this.thamsoDT;
        if (!this.thamsoTruoc) this.thamsoTruoc = {};
      }

      this.showLogDetail = true;
    },

    findLog(a, b) {
      this.pageRequest.pageNum = a;
      this.pageRequest.pageSize = b;
      this.store.dispatch(CounterLog.findPageCounterLog, this.pageRequest).then((res) => {
        if (res.code == 200 && res.data)
          this.dataLog = res.data;
        else
          this.dataLog = []
      });
    },


    handleSearch() {
      const tuPart = this.pageRequest.columnFilters.tuNgay.value.split('/');
      const tu = new Date(+tuPart[2], tuPart[1] - 1, +tuPart[0])
      const denPart = this.pageRequest.columnFilters.denNgay.value.split('/');
      const den = new Date(+denPart[2], denPart[1] - 1, +denPart[0])
      if (tu > den || tu > Date.now()) ElMessage({ message: "Mốc thời gian không hợp lệ !", type: "error" })
      else this.findLog(1, 30);
    },


    handleSizeChange(val) {
      this.findLog(this.pageRequest.pageNum, val);
    },
    handleCurrentChange(val) {
      this.findLog(val, this.pageRequest.pageSize);
    },
    handleGetService() {
      this.store.dispatch(Service.getServiceList).then(res => {
        if (res.code == 200) {
          this.service = res.data
        }
      }).catch((error) => {
        ElMessage({ message: "Tìm dịch vụ thất bại", type: "error" });
      })
    },
    handleGetEmployee() {
      this.store.dispatch(Employee.getEmployeeList).then(res => {
        if (res.code == 200) {
          this.employee = res.data
        }
      }).catch((error) => {
        ElMessage({ message: "Tìm nhân viên thất bại", type: "error" });
      })
    },
    handleGetBooth() {
      this.store.dispatch(Booth.getBoothList).then(res => {
        if (res.code == 200) {
          this.booth = res.data
        }
      }).catch((error) => {
        ElMessage({ message: "Tìm quầy thất bại", type: "error" });
      })
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    },
  },
  mounted() {
    this.handleGetService();
    this.handleGetEmployee();
    this.handleGetBooth();
    this.findLog(1, 30);
  },
};
</script>
<style scoped>
fieldset {
  border: 1px solid rgb(223, 215, 215) !important;
  font-size: 13px !important;
}

fieldset.ttkhachhang {
  height: calc(100% - 36px);
}

legend {
  width: auto !important;
  font-size: 13px !important;
  margin-left: 32px !important;
}

.log-bg {

  /* height: 100vh;
    width: 100vw; */
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
}

.log-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  fieldset {
    min-width: 100px;
    margin-left: 1rem;
    margin-right: 1rem;
  }
}

.modal-log__detail {
  margin: auto;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 10px;
  border: 1px #c1c1c1 solid;
  width: 80%;
}

.btn__xacnhan {
  background-color: #66b1ff;
  color: white;
  width: fit-content;
  border-radius: 5px;
  padding: 0px 7px;
  cursor: pointer;
  margin-bottom: 10px;
  margin-left: calc(100% - 100px);
}

.tbl {
  height: calc(100vh - 250px);
}

.item-date-control {
  flex: auto;
  width: auto;
}

.box-card {
  margin: 10px;
}

h6 {
  margin-bottom: 0px;
}
</style>
<style>
.item-date-control .el-input__inner {
  color: #000;
  border: 1px solid #b1b4b8;
  height: 1.6rem;
}

.item-date-control .el-input__icon {
  line-height: 1.6rem;
  height: 1.6rem;
}
</style>
